import { FS_ENTRY_TYPES, PATHS, VIRTUAL_FS_DATA } from './constants.js';

/**
 * Simulated in-browser filesystem used by the `ls`, `cd`, and `cat` terminal commands.
 * The structure is a plain-object tree mirroring a Unix-style directory layout.
 */
export const VIRTUAL_FS = {
    [PATHS.ROOT]: {
        type: FS_ENTRY_TYPES.DIR,
        children: {
            [VIRTUAL_FS_DATA.ABOUT_NAME]: {
                type: FS_ENTRY_TYPES.FILE,
                content: VIRTUAL_FS_DATA.ABOUT_CONTENT,
            },
            [VIRTUAL_FS_DATA.SKILLS_NAME]: {
                type: FS_ENTRY_TYPES.FILE,
                content: VIRTUAL_FS_DATA.SKILLS_CONTENT,
            },
            [VIRTUAL_FS_DATA.CONTACT_NAME]: {
                type: FS_ENTRY_TYPES.FILE,
                content: VIRTUAL_FS_DATA.CONTACT_CONTENT,
            },
            [VIRTUAL_FS_DATA.PROJECTS_DIR_NAME]: {
                type: FS_ENTRY_TYPES.DIR,
                children: {
                    [VIRTUAL_FS_DATA.SCHEDULER_NAME]: {
                        type: FS_ENTRY_TYPES.FILE,
                        content: VIRTUAL_FS_DATA.SCHEDULER_CONTENT,
                    },
                    [VIRTUAL_FS_DATA.ORDER_ENGINE_NAME]: {
                        type: FS_ENTRY_TYPES.FILE,
                        content: VIRTUAL_FS_DATA.ORDER_ENGINE_CONTENT,
                    },
                    [VIRTUAL_FS_DATA.CACHE_PROXY_NAME]: {
                        type: FS_ENTRY_TYPES.FILE,
                        content: VIRTUAL_FS_DATA.CACHE_PROXY_CONTENT,
                    },
                },
            },
        },
    },
};

export let currentPath = PATHS.ROOT;

/** @returns {string} The current working directory path. */
export function getCurrentPath() {
    return currentPath;
}

/** @param {string} path - The new current working directory path. */
export function setCurrentPath(path) {
    currentPath = path;
}

/**
 * Traverses the virtual filesystem tree and returns the node at {@code pathStr},
 * or {@code null} if the path does not exist.
 *
 * Accepts both absolute paths (starting with `/`) and paths relative to {@link currentPath}.
 *
 * @param {string} pathStr
 * @returns {{ type: string, children?: object, content?: string } | null}
 */
export function getDirNode(pathStr) {
    if (pathStr === PATHS.ROOT) return VIRTUAL_FS[PATHS.ROOT];

    // Resolve relative paths against the current directory
    const cleanPath = pathStr.startsWith(PATHS.ROOT)
        ? pathStr
        : (currentPath === PATHS.ROOT ? `/${pathStr}` : `${currentPath}/${pathStr}`);

    const parts = cleanPath.split('/').filter(p => p);
    let node = VIRTUAL_FS[PATHS.ROOT];

    for (const part of parts) {
        if (node.type === FS_ENTRY_TYPES.DIR && node.children[part]) {
            node = node.children[part];
        } else {
            return null;
        }
    }
    return node;
}

/**
 * Returns the list of child names for the current working directory.
 *
 * @returns {string[]}
 */
export function getFilesForCurrentDir() {
    const node = getDirNode(currentPath);
    return (node?.type === FS_ENTRY_TYPES.DIR) ? Object.keys(node.children) : [];
}
